export const generateGalleryId = () => {
  const random = Math.random().toString(36).substring(2, 8).toUpperCase();
  return `GAL-${Date.now().toString().slice(-6)}${random}`;
};

export const validateGalleryData = (data) => {
  const errors = {};
  if (!data.name?.trim()) errors.name = "Gallery name is required";
  if (!data.category) errors.category = "Category is required";
  return errors;
};

export const getGalleryStatusDisplay = (status) => {
  const map = {
    active: { label: "Active", color: "success" },
    draft: { label: "Draft", color: "default" },
    archived: { label: "Archived", color: "warning" },
  };
  return map[status] || { label: status, color: "default" };
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};

export const getVisibleImages = (images = []) => {
  return images.filter((img) => !img.isDeleted);
};

export const getNextDisplayOrder = (images = []) => {
  if (images.length === 0) return 1;
  return Math.max(...images.map((i) => i.displayOrder || 0)) + 1;
};
